import * as Yup from 'yup';

export const PortfolioValidation = Yup.object().shape({
    portfolioName: Yup.string().required('f:validation.required'),
    imageUrl: Yup.string(),
    listOfProperties: Yup.array().min(1).typeError('f:validation.required'),
});
